export { default } from "./contactDetailsInfo";
